import { createTRPCClient, httpBatchLink } from '@trpc/client';

import { createTrpcWithCache, WithTrpcCache } from './trpcWithCache';
import { BlogApiRouter } from '../../server/blogApiRouter';

const blogTrpcClient = createTRPCClient<BlogApiRouter>({
    links: [
        httpBatchLink({
            url: '/blogApi',
        }),
    ],
});

export const blogApiClient = createTrpcWithCache(blogTrpcClient) as WithTrpcCache<
    typeof blogTrpcClient
>;
